export abstract class CasinoWindowEvent {}
export class LobbyLoadedEvent extends CasinoWindowEvent {}
export class RecentCasinoGameOpenEvent extends CasinoWindowEvent {
    gamename: string;
}
export class RecentCasinoGameCloseEvent extends CasinoWindowEvent {}
export class ShowLoginEvent extends CasinoWindowEvent {
    gamename: string;
}
export class PingStatusGameOpenEvent extends CasinoWindowEvent {}
export class WindowScrollStartEvent extends CasinoWindowEvent {
    data: WindowScrollEventData;
}

export class WindowScrollEventData {
    clientX: number;
    clientY: number;
    deltaX: number;
    deltaY: number;
    layerX: number;
    layerY: number;
    offsetX: number;
    offsetY: number;
    pageX: number;
    pageY: number;
    wheelDeltaX: number;
    wheelDeltaY: number;
    x: number;
    y: number;
}
export enum CasinoEventType {
    LobbyLoaded = 'LOBBY_LOADED',
    RecentCasinoGameOpen = 'RECENT_CASINO_GAME_OPEN',
    RecentCasinoGameClose = 'RECENT_CASINO_GAME_CLOSE',
    ShowLogin = 'SHOW_LOGIN',
    PingStatusGameOpen = 'PING_STATUS_GAME_OPEN',
    WindowScrollStart = 'WINDOW_SCROLL_START',
    WindowScrollStop = 'WINDOW_SCROLL_STOP',
}
